import * as z from 'zod';
export const contentTypeSchema = z.enum(['VIDEO', 'LIVE', 'AUDIO', 'GAME']);
/**
 * Content providers available in the current milestone.
 *
 * IPTV providers are deliberately absent: exposing them requires a decision on
 * credential handling that has not been made yet. See ARCHITECTURE.md §8.
 */
export const providerIdSchema = z.enum(['LOCAL', 'YOUTUBE']);
/**
 * How the client should play a resolved item.
 *
 * `PROVIDER_WEBVIEW` is confined to a single content surface. It never carries
 * navigation or rule enforcement. See AGENTS.md §6.
 */
export const playerKindSchema = z.enum(['PROGRESSIVE', 'HLS', 'YOUTUBE_EMBED', 'LOCAL_FILE']);
//# sourceMappingURL=content.js.map